<script>
import * as constants from '@/utilities/appConsts'
import _ from 'lodash'

export default {
  computed: {
    clickedParameterIsPlottable() {
      if (this.clickedParameter) {
        return (
          this.clickedParameter.isPlottable === undefined ||
          this.clickedParameter.isPlottable
        )
      }
      return false
    },
    clickedParameterId() {
      if (this.clickedParameter && this.clickedParameter.parameterId) {
        return this.clickedParameter.parameterId
      }
      return -1
    },
    clickedParameterUniqueId() {
      if (this.clickedParameter && this.clickedParameter.uniqueId) {
        return this.clickedParameter.uniqueId
      }
      return ''
    },
    clickedParameterAlertEnabled() {
      if (this.clickedParameter) {
        return (
          this.clickedParameter.alertEnabled === undefined ||
          this.clickedParameter.alertEnabled
        )
      }
      return false
    },
    getReportStatus() {
      if (this.clickedParameter) {
        if (this.clickedParameter.status !== undefined) {
          return this.clickedParameter.status
        }
      }
      return constants.STATUS_VALUES.normal
    },
    getReportCellFaultMonitors() {
      if (this.clickedParameter && this.clickedParameter.faultMonitorIds) {
        const ids = this.clickedParameter.faultMonitorIds
        const fms = this.faultMonitors
          .filter(item => ids.indexOf(item.faultMonitorId) > -1)
          .reduce((unique, item) => {
            const isItemFound = unique.filter(
              child => child.faultMonitorId === item.faultMonitorId,
            )
            return isItemFound.length > 0 ? unique : [...unique, item]
          }, [])
          .map(item => {
            return {
              title: `${item.code}    ${item.title}`,
              faultMonitorId: item.faultMonitorId,
            }
          })
        return fms
      }
      return []
    },
    getGroupedFaultMonitors() {
      if (this.faultMonitors) {
        const grouped = _.groupBy(this.faultMonitors, item => {
          return item.name + '--' + item.hexCode + '--' + item.count
        })
        const mapped = Object.keys(grouped).map((item, index) => {
          return {
            name: item.split('--')[0],
            hexCode: item.split('--')[1],
            count: item.split('--')[2],
            values: Object.values(grouped)[index],
          }
        })
        return mapped
      }
      return []
    },
    plotTabVisible() {
      if (
        !this.isReportDataLoading &&
        this.reportType &&
        this.graphGroupsPerReportType.length
      ) {
        const hasGraphGroups = this.graphGroupsPerReportType.filter(
          item => item.acmfReportNumber === this.reportType.acmfReportNumber,
        )
        return hasGraphGroups.length > 0
      }
      return false
    },
  },

  methods: {
    getFaultMonitorGivenId(id) {
      const items = this.faultMonitors.filter(
        item => item.faultMonitorId === id,
      )
      return items.length > 0 ? items[0] : {}
    },
    getReportObjectGivenId() {
      const tableId = this.clickedParameterUniqueId.split('__')[0]
      const items = this.reportDataWithUniqueIds.filter(item => {
        return item.uniqueId === tableId
      })
      return items.length > 0 ? items[0] : {}
    },
    isReportObjectSeriesData() {
      const reportObject = this.getReportObjectGivenId()
      if (reportObject) {
        return reportObject.seriesData
      }
      return false
    },
    getSeriesDataForGraph() {
      const reportObject = this.getReportObjectGivenId()
      const uniqueId = this.clickedParameterUniqueId
      const colIndex = uniqueId.split('__')[1]
      const items = []
      if (reportObject && reportObject.seriesData) {
        const values = reportObject.values
        values.forEach(item => {
          const xText = item[0].text
          const isLRSeriesData = xText === 'L' || xText === 'R'
          if (isLRSeriesData) {
            const point = {
              x: parseFloat(item[1].text),
              y: parseFloat(item[colIndex].text),
            }
            items.push(point)
          } else {
            const point = {
              x: parseFloat(item[0].text),
              y: parseFloat(item[colIndex].text),
            }
            items.push(point)
          }
        })
      }
      return items
    },
  },
}
</script>
